import { SvgIcon } from '@mui/material'

const SvgGroups3 = (props) => (
  <SvgIcon viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" name="SvgGroups3" {...props}>
    <style>
      {
        '.groups3_svg__st0{fill:#bfd5de}.groups3_svg__st2{fill:#d3a489}.groups3_svg__st3{fill:#bf8e75}.groups3_svg__st4{fill:#3d4159}.groups3_svg__st5{fill:#fff}.groups3_svg__st6{fill:#2a2f4f}.groups3_svg__st7{fill:#d8d5d0}.groups3_svg__st8{fill:#eab599}.groups3_svg__st9{fill:#f6caae}.groups3_svg__st12{fill:#e8c934}.groups3_svg__st13{fill:#ffe152}'
      }
    </style>
    <path
      className="groups3_svg__st0"
      d="M489.023 330.102v32.047c-25.223 55.285-69.539 100.02-124.512 125.785a254.027 254.027 0 01-30.887 12.07 251.557 251.557 0 01-36.902 8.766c-.055.008-.117.02-.168.02V330.102c0-38.086 29.328-69.328 66.652-72.336a69.599 69.599 0 015.934-.242h47.273c5.59 0 11.035.617 16.258 1.82 32.267 7.375 56.352 36.266 56.352 70.758z"
    />
    <path
      d="M489.023 330.102v32.047c-25.223 55.285-69.539 100.02-124.512 125.785a254.027 254.027 0 01-30.887 12.07V330.102c0-40.082 32.508-72.578 72.602-72.578h10.195c40.106 0 72.602 32.496 72.602 72.578z"
      fill="#dde8ed"
    />
    <path
      className="groups3_svg__st2"
      d="M321.738 177.465c0 11.988-8.762 21.93-20.23 23.777-1.25.203-2.543.309-3.855.309-13.309 0-24.086-10.781-24.086-24.086s10.777-24.086 24.086-24.086c1.312 0 2.605.105 3.855.309 11.469 1.848 20.23 11.789 20.23 23.777z"
    />
    <path
      className="groups3_svg__st3"
      d="M321.738 177.465c0 11.988-8.762 21.93-20.23 23.777a89.613 89.613 0 01-3.195-23.777 89.63 89.63 0 013.195-23.777c11.469 1.848 20.23 11.789 20.23 23.777z"
    />
    <path className="groups3_svg__st3" d="M306.262 177.465a8.61 8.61 0 11-17.22-.002 8.61 8.61 0 0117.22.002z" />
    <path
      className="groups3_svg__st0"
      d="M392.781 287.235l-32.684 18.164-9.941-46.242 20.309-11.961M392.781 287.235l32.68 18.164 9.941-46.242-20.305-11.961"
    />
    <path
      className="groups3_svg__st2"
      d="M463.828 177.465c0 11.988 8.758 21.93 20.227 23.777 1.254.203 2.547.309 3.859.309 13.309 0 24.086-10.781 24.086-24.086s-10.777-24.086-24.086-24.086c-1.312 0-2.605.105-3.859.309-11.469 1.848-20.227 11.789-20.227 23.777z"
    />
    <path
      className="groups3_svg__st3"
      d="M463.828 177.465c0 11.988 8.758 21.93 20.227 23.777a89.45 89.45 0 003.199-23.777 89.467 89.467 0 00-3.199-23.777c-11.469 1.848-20.227 11.789-20.227 23.777z"
    />
    <path className="groups3_svg__st3" d="M496.523 177.465a8.61 8.61 0 11-17.22-.002 8.61 8.61 0 0117.22.002z" />
    <path
      className="groups3_svg__st3"
      d="M482.398 164.665c0 44.594-32.578 81.59-75.23 88.457a88.544 88.544 0 01-14.383 1.156c-49.496 0-89.617-40.117-89.617-89.613 0-23.418 8.137-58.574 22.84-74.539 16.379-17.777 40.699-15.078 66.777-15.078 4.898 0 9.703.391 14.383 1.16 42.652 6.867 75.23 43.859 75.23 88.457z"
    />
    <path
      className="groups3_svg__st3"
      d="M418.684 229.555v31.785c0 11.637-7.672 21.473-18.242 24.738a25.844 25.844 0 01-7.66 1.156c-14.305 0-25.898-11.59-25.898-25.895v-31.785h51.8z"
    />
    <path
      className="groups3_svg__st2"
      d="M418.684 259.329v2.012c0 11.637-7.672 21.473-18.242 24.742-9.535-2.934-16.703-11.223-18.027-21.367a88.628 88.628 0 0019.602-1 88.188 88.188 0 0016.667-4.387zM482.398 164.665c0 44.594-32.578 81.59-75.23 88.457-42.656-6.867-75.234-43.863-75.234-88.457 0-27.461 12.352-52.039 31.812-68.48 12.129-10.258 27.035-17.34 43.422-19.98 39.766 6.402 70.781 39 74.789 79.523.293 2.94.441 5.925.441 8.937z"
    />
    <path
      className="groups3_svg__st3"
      d="M392.785 208.801c-7.504 0-15.008-1.883-21.848-5.641-1.93-1.062-2.637-3.484-1.574-5.414s3.484-2.633 5.414-1.574c11.277 6.199 24.738 6.199 36.016 0a3.99 3.99 0 015.414 1.574 3.989 3.989 0 01-1.574 5.414c-6.84 3.758-14.344 5.641-21.848 5.641z"
    />
    <path
      className="groups3_svg__st4"
      d="M373.699 159.446c0 5.617-4.551 10.168-10.164 10.168a10.166 10.166 0 01-10.168-10.168c0-5.613 4.551-10.164 10.168-10.164 5.613 0 10.164 4.551 10.164 10.164zM432.199 159.446c0 5.617-4.551 10.168-10.164 10.168s-10.168-4.551-10.168-10.168c0-5.613 4.555-10.164 10.168-10.164s10.164 4.551 10.164 10.164z"
    />
    <path
      className="groups3_svg__st5"
      d="M371.629 157.653a4.357 4.357 0 01-8.714 0 4.357 4.357 0 018.714 0zM430.629 157.653a4.357 4.357 0 01-8.714 0 4.357 4.357 0 018.714 0z"
    />
    <path
      className="groups3_svg__st3"
      d="M402.949 185.043h-20.332c-2.422 0-4.383-1.965-4.383-4.387s1.961-4.383 4.383-4.383h20.332a4.385 4.385 0 110 8.77z"
    />
    <path className="groups3_svg__st0" d="M422.289 327.723h39.066v11.961h-39.066v-11.961z" />
    <path
      className="groups3_svg__st6"
      d="M387.539 49.446c27.148 1.941 48.945 23.871 50.324 51.477l.258 5.184h15.617l8.41 55.93 20.371-6.305-2.734-54.809c-1.445-28.996-25.43-51.723-54.453-51.617l-37.793.14z"
    />
    <path
      className="groups3_svg__st4"
      d="M478.059 27.817c21.617 21.617 21.617 56.668 0 78.285s-56.668 21.617-78.285 0l78.285-78.285z"
    />
    <path
      className="groups3_svg__st4"
      d="M399.777 106.102h-67.941l-8.414 55.934-20.371-6.305 2.734-54.809c1.441-28.992 25.426-51.727 54.453-51.617l98.121.371 12.973 23.348"
    />
    <path
      className="groups3_svg__st6"
      d="M398.027 49.446c-27.145 1.941-48.941 23.871-50.324 51.477l-.258 5.184h-15.613l-8.414 55.93-20.371-6.305 2.738-54.809c1.441-28.996 25.426-51.723 54.449-51.617l37.793.14z"
    />
    <g>
      <path
        className="groups3_svg__st4"
        d="M201.293 332.247v173.891c-80.781-17.586-147.32-73.301-179.816-147.352v-26.539c0-31.379 21.305-57.785 50.246-65.516a53.138 53.138 0 013.211-.785 66.062 66.062 0 018.816-1.293c1.828-.148 3.68-.23 5.551-.23h44.168c4.941 0 9.746.52 14.387 1.523.273.055.531.117.793.18.785.176 1.559.363 2.332.574a.372.372 0 00.062.02 67.333 67.333 0 0121.055 9.77c17.648 12.245 29.195 32.651 29.195 55.757z"
      />
      <path
        className="groups3_svg__st7"
        d="M111.379 292.188l-30.531 16.969-9.289-43.203 18.973-11.176M111.379 292.188l30.535 16.969 9.289-43.203-18.973-11.176"
      />
      <path
        className="groups3_svg__st8"
        d="M135.582 238.297v29.699c0 10.871-7.168 20.059-17.043 23.109a24.067 24.067 0 01-7.156 1.082c-13.363 0-24.195-10.828-24.195-24.195v-29.695h48.394z"
      />
      <path
        className="groups3_svg__st9"
        d="M135.582 266.114v1.883c0 10.871-7.168 20.059-17.043 23.109-8.906-2.738-15.605-10.484-16.844-19.961a82.76 82.76 0 0018.313-.934 82.12 82.12 0 0015.574-4.097zM45.004 189.629c0 11.203-8.18 20.492-18.895 22.215a22.427 22.427 0 01-3.605.289C10.07 212.133 0 202.063 0 189.629c0-12.43 10.07-22.504 22.504-22.504 1.227 0 2.434.102 3.605.289 10.715 1.727 18.895 11.012 18.895 22.215z"
      />
      <path
        className="groups3_svg__st8"
        d="M45.004 189.629c0 11.203-8.18 20.492-18.895 22.215-1.949-7.078-2.988-14.527-2.988-22.215s1.039-15.137 2.988-22.215c10.715 1.727 18.895 11.012 18.895 22.215z"
      />
      <path
        className="groups3_svg__st8"
        d="M30.547 189.629c0 4.441-3.602 8.043-8.043 8.043s-8.043-3.602-8.043-8.043 3.602-8.043 8.043-8.043 8.043 3.602 8.043 8.043z"
      />
      <path
        className="groups3_svg__st9"
        d="M177.762 189.629c0 11.203 8.184 20.492 18.898 22.215a22.39 22.39 0 003.605.289c12.43 0 22.5-10.07 22.5-22.504 0-12.43-10.07-22.504-22.5-22.504-1.23 0-2.434.102-3.605.289-10.715 1.727-18.898 11.012-18.898 22.215z"
      />
      <path
        className="groups3_svg__st8"
        d="M177.762 189.629c0 11.203 8.184 20.492 18.898 22.215 1.945-7.078 2.984-14.527 2.984-22.215s-1.039-15.137-2.984-22.215c-10.715 1.727-18.898 11.012-18.898 22.215z"
      />
      <path
        className="groups3_svg__st8"
        d="M195.109 145.79v31.883c0 41.664-30.438 76.227-70.289 82.641-.133.023-.277.043-.41.066a82.199 82.199 0 01-13.027 1.016c-46.238 0-83.723-37.484-83.723-83.723V145.79c0-9.738 1.66-19.094 4.73-27.785C43.839 85.423 74.886 62.06 111.382 62.06h.004c4.434 0 8.793.344 13.039 1.012 40.048 6.261 70.684 40.913 70.684 82.718z"
      />
      <path className="groups3_svg__st8" d="M208.305 189.629a8.04 8.04 0 11-16.082 0 8.042 8.042 0 1116.082 0z" />
      <path
        className="groups3_svg__st9"
        d="M195.109 145.79v31.883c0 41.664-30.438 76.227-70.289 82.641-.133.023-.277.043-.41.066-40.047-6.258-70.676-40.91-70.676-82.707V145.79c0-41.805 30.637-76.457 70.691-82.719 40.048 6.262 70.684 40.914 70.684 82.719z"
      />
      <path
        className="groups3_svg__st4"
        d="M93.555 172.797c0 5.242-4.254 9.496-9.5 9.496-5.242 0-9.496-4.254-9.496-9.496 0-5.246 4.254-9.5 9.496-9.5 5.246 0 9.5 4.254 9.5 9.5zM148.211 172.797c0 5.242-4.25 9.496-9.496 9.496s-9.5-4.254-9.5-9.496c0-5.246 4.254-9.5 9.5-9.5s9.496 4.254 9.496 9.5z"
      />
      <path
        className="groups3_svg__st5"
        d="M91.617 171.122a4.066 4.066 0 01-4.07 4.066 4.069 4.069 0 110-8.136 4.067 4.067 0 014.07 4.07zM146.742 171.122c0 2.246-1.824 4.066-4.07 4.066a4.069 4.069 0 114.07-4.066z"
      />
      <path
        className="groups3_svg__st8"
        d="M120.883 192.985h-18.996a4.097 4.097 0 110-8.196h18.996c2.262 0 4.098 1.836 4.098 4.098s-1.836 4.098-4.098 4.098zM111.383 218.907c-7.008 0-14.02-1.758-20.41-5.27a3.726 3.726 0 01-1.469-5.059 3.722 3.722 0 015.059-1.469c10.535 5.789 23.113 5.789 33.648 0a3.718 3.718 0 015.055 1.469 3.723 3.723 0 01-1.469 5.059c-6.391 3.512-13.402 5.27-20.414 5.27z"
      />
      <path
        d="M195.109 116.856v32.66h-15.582v-25.578L67.043 103.036 43.242 98.61v50.906H27.66v-32.66c0-37.23 30.176-67.406 67.398-67.406h32.648c.887 0 1.773.012 2.66.059 35.989 1.382 64.743 31.003 64.743 67.347z"
        fill="#664a36"
      />
      <path
        d="M195.109 116.856v32.66h-15.582v-25.578L67.043 103.036c6.199-29.766 32.023-52.32 63.324-53.527 35.988 1.382 64.742 31.003 64.742 67.347z"
        fill="#774e32"
      />
    </g>
    <g>
      <path
        className="groups3_svg__st12"
        d="M373.486 435.928v48.061C337.949 500.676 298.257 512 256.388 512c-20.231 0-39.961-2.172-58.955-6.314a273.587 273.587 0 01-22.534-5.923c-13.614-4.201-26.79-11.438-39.41-17.596v-46.238c0-41.527 28.196-76.471 66.503-86.717 1.398-.37 2.804-.72 4.235-1.023a90.174 90.174 0 0111.686-1.726 88.24 88.24 0 017.341-.29h58.454c6.529 0 12.902.686 19.04 2.016.349.067.711.143 1.048.223 1.036.236 2.071.497 3.086.779.034 0 .055 0 .076.008a89.121 89.121 0 0127.872 12.94c23.363 16.202 38.656 43.215 38.656 73.789z"
      />
      <path
        className="groups3_svg__st13"
        d="M373.486 435.928v48.061C337.949 500.676 298.257 512 256.388 512c-20.231 0-39.961-2.172-58.955-6.314a273.587 273.587 0 01-22.534-5.923v-63.835c0-41.527 28.196-76.471 66.503-86.717 1.398-.37 2.804-.72 4.235-1.023a90.174 90.174 0 0111.686-1.726 88.31 88.31 0 017.341-.29h19.044c6.529 0 12.902.686 19.04 2.016.349.067.711.143 1.048.223 1.036.236 2.071.497 3.086.779.034 0 .055 0 .076.008a89.121 89.121 0 0127.872 12.94c23.363 16.203 38.656 43.216 38.656 73.79z"
      />
      <path
        className="groups3_svg__st12"
        d="M373.486 435.928v48.061C337.949 500.676 298.257 512 256.388 512c-20.231 0-39.961-2.172-58.955-6.314a273.587 273.587 0 01-22.534-5.923c-13.614-4.201-26.79-11.438-39.41-17.596v-46.238c0-41.527 28.196-76.471 66.503-86.717 1.398-.37 2.804-.72 4.235-1.023a90.174 90.174 0 0111.686-1.726 88.24 88.24 0 017.341-.29h58.454c6.529 0 12.902.686 19.04 2.016.349.067.711.143 1.048.223 1.036.236 2.071.497 3.086.779.034 0 .055 0 .076.008a89.121 89.121 0 0127.872 12.94c23.363 16.202 38.656 43.215 38.656 73.789z"
      />
      <path
        className="groups3_svg__st13"
        d="M373.486 435.928v48.061C337.949 500.676 298.257 512 256.388 512c-20.231 0-39.961-2.172-58.955-6.314a273.587 273.587 0 01-22.534-5.923v-63.835c0-41.527 28.196-76.471 66.503-86.717 1.398-.37 2.804-.72 4.235-1.023a90.174 90.174 0 0111.686-1.726 88.31 88.31 0 017.341-.29h19.044c6.529 0 12.902.686 19.04 2.016.349.067.711.143 1.048.223 1.036.236 2.071.497 3.086.779.034 0 .055 0 .076.008a89.121 89.121 0 0127.872 12.94c23.363 16.203 38.656 43.216 38.656 73.79z"
      />
      <path
        d="M307.185 348.188l-.227 1.01-28.137 130.901c-7.4.598-14.877.901-22.433.901-8.87 0-17.668-.417-26.335-1.25l-28.061-130.539-.227-1.023h105.42z"
        fill="#f2f0ec"
      />
      <path
        className="groups3_svg__st7"
        d="M254.473 382.913l-40.408 22.458-12.296-57.183 25.11-14.788M254.473 382.913l40.412 22.458 12.292-57.183-25.106-14.788"
      />
      <path
        d="M133.822 324.526V189.155c0-13.757 2.294-27.232 6.82-40.054 16.944-48.212 62.693-80.618 113.839-80.618 6.335 0 12.658.493 18.8 1.465 28.103 4.391 53.883 18.733 72.577 40.387 18.893 21.886 29.294 49.879 29.294 78.82v135.371"
        fill="#f74f4f"
      />
      <path
        d="M183.458 194.442c0 47.884 28.036 103.278 43.434 130.084h-93.074V189.155c0-13.753 2.294-27.228 6.82-40.054 16.838-47.934 62.171-80.243 112.964-80.605-37.099.926-70.144 60.441-70.144 125.946z"
        fill="#dd3033"
      />
      <path
        className="groups3_svg__st8"
        d="M286.512 311.59v39.301c0 14.388-9.488 26.55-22.555 30.591a32.036 32.036 0 01-9.476 1.431c-17.684 0-32.022-14.338-32.022-32.022V311.59h64.053z"
      />
      <path
        className="groups3_svg__st9"
        d="M286.512 348.403v2.488c0 14.388-9.488 26.55-22.555 30.591-11.791-3.624-20.656-13.875-22.294-26.419 2.138.13 4.29.194 6.453.194 6.058 0 11.997-.48 17.785-1.427a109.287 109.287 0 0020.611-5.427zM166.636 247.175c0 14.826-10.831 27.122-25.009 29.404a30.234 30.234 0 01-4.774.379c-16.451 0-29.783-13.328-29.783-29.783 0-16.451 13.332-29.779 29.783-29.779 1.629 0 3.22.13 4.774.379 14.178 2.282 25.009 14.574 25.009 29.4z"
      />
      <path
        className="groups3_svg__st8"
        d="M166.636 247.175c0 14.826-10.831 27.122-25.009 29.404a110.76 110.76 0 01-3.953-29.404c0-10.175 1.377-20.029 3.953-29.4 14.178 2.282 25.009 14.574 25.009 29.4z"
      />
      <path
        className="groups3_svg__st8"
        d="M147.499 247.175c0 5.881-4.765 10.646-10.646 10.646-5.877 0-10.642-4.765-10.642-10.646 0-5.877 4.765-10.642 10.642-10.642 5.881 0 10.646 4.766 10.646 10.642z"
      />
      <path
        className="groups3_svg__st8"
        d="M330.957 209.15v102.373c-15.824 15.104-36.114 25.565-58.69 29.202l-.543.088c-5.607.897-11.366 1.343-17.242 1.343-61.195 0-110.804-49.61-110.804-110.804v-42.197c0-5.401.387-10.718 1.137-15.912 26.36 18.96 64.162 17.087 88.245-5.679 7.977-7.531 13.517-16.502 16.653-26.015 1.743 16.661 9.366 32.877 22.871 45.644 16.079 15.184 37.325 22.508 58.373 21.957z"
      />
      <path
        className="groups3_svg__st9"
        d="M330.957 209.15v102.373c-15.824 15.104-36.114 25.565-58.69 29.202l-.543.088c-52.999-8.28-93.537-54.144-93.537-109.462v-42.197c0-1.124.017-2.235.059-3.351 19.541 2 39.827-4.071 54.813-18.24 7.977-7.531 13.517-16.502 16.653-26.015 1.747 16.661 9.366 32.877 22.871 45.644 16.08 15.185 37.326 22.509 58.374 21.958z"
      />
      <path
        className="groups3_svg__st8"
        d="M313.992 221.993c0-10.166-8.238-18.404-18.4-18.404-10.166 0-18.404 8.238-18.404 18.404M231.796 221.993c0-10.166-8.238-18.404-18.404-18.404-10.162 0-18.4 8.238-18.4 18.404"
      />
      <path
        className="groups3_svg__st4"
        d="M225.962 229.827c0 6.942-5.628 12.57-12.57 12.57s-12.57-5.628-12.57-12.57 5.628-12.57 12.57-12.57 12.57 5.629 12.57 12.57zM308.162 229.827c0 6.942-5.628 12.57-12.57 12.57-6.946 0-12.57-5.628-12.57-12.57s5.624-12.57 12.57-12.57c6.942.001 12.57 5.629 12.57 12.57z"
      />
      <path
        className="groups3_svg__st8"
        d="M267.06 261.475h-25.14a5.421 5.421 0 110-10.844h25.14a5.421 5.421 0 015.422 5.422 5.419 5.419 0 01-5.422 5.422zM254.49 295.783c-9.278 0-18.556-2.328-27.013-6.975a4.925 4.925 0 01-1.945-6.693 4.924 4.924 0 016.693-1.945c13.942 7.666 30.591 7.666 44.533 0a4.926 4.926 0 016.693 1.945 4.925 4.925 0 01-1.945 6.693c-8.456 4.651-17.734 6.975-27.016 6.975z"
      />
      <path
        className="groups3_svg__st5"
        d="M223.398 227.609c0 2.976-2.408 5.384-5.384 5.384s-5.384-2.408-5.384-5.384 2.408-5.384 5.384-5.384 5.384 2.408 5.384 5.384zM306.213 227.609c0 2.976-2.408 5.384-5.384 5.384s-5.384-2.408-5.384-5.384 2.408-5.384 5.384-5.384 5.384 2.408 5.384 5.384z"
      />
      <path
        className="groups3_svg__st8"
        d="M329.909 260.444c0 7.624-6.18 13.803-13.803 13.803s-13.803-6.18-13.803-13.803c0-7.624 6.18-13.803 13.803-13.803s13.803 6.179 13.803 13.803zM206.673 260.444c0 7.624-6.18 13.803-13.803 13.803s-13.803-6.18-13.803-13.803c0-7.624 6.18-13.803 13.803-13.803s13.803 6.179 13.803 13.803z"
      />
    </g>
  </SvgIcon>
)

export default SvgGroups3
